export type HistoryPushEvent = CustomEvent<{ path: string }>;

export interface History {
  push: (path: string) => void;
}
export const historyEventBus = new EventTarget();
export const history: History = {
  push: (path: string) => historyEventBus.dispatchEvent(new CustomEvent('history:push', { detail: { path } })),
};
